const productPaths = {
  products: '/product',
  editProduct: (id = ':id') => `/product/${id}/edit`,
  variants: (id = ':id') => `/product/${id}/variants`,
  productSettings: '/product/settings',
};

export default productPaths;
